import { useEffect, useState } from 'react';

import { LiveQuizPublicQuestion } from '../../types/index.ts';

function useQuestionCountdown(question: LiveQuizPublicQuestion | null): { secondsRemaining: number; progress: number } {
    const [secondsRemaining, setSecondsRemaining] = useState(0);

    useEffect(() => {
        if (!question) {
            setSecondsRemaining(0);
            return;
        }

        const clockOffsetMs = new Date(question.serverTime).getTime() - Date.now();
        const endsAtMs = new Date(question.endsAt).getTime();

        const tick = () => {
            const remainingMs = endsAtMs - (Date.now() + clockOffsetMs);
            setSecondsRemaining(Math.max(0, Math.ceil(remainingMs / 1000)));
        };

        tick();
        const interval = setInterval(tick, 250);
        return () => clearInterval(interval);
    }, [question]);

    const progress = question && question.timeLimit > 0 ? secondsRemaining / question.timeLimit : 0;

    return { secondsRemaining, progress };
}

export default useQuestionCountdown;
